.tracker {
    width: 10px;
    height: 10px;
    z-index: 5000;
    pointer-events: none;
}
